// 订阅管理
import { createAPI } from '@common'

export default {
  // 读订阅分类接口
  getColumnsRssCats: (config) =>
    createAPI('customEncryptApiName-1/0w20dpmvnot0sttDbut', 'get', config),
  // 微信公众号设置
  getColumnsWeixin: (config) => createAPI('customEncryptApiName-1/0w20dpmvnot0xfjyjo', 'get', config),
  // 微信公众号设置
  postColumnsWeixin: (config) => createAPI('customEncryptApiName-1/0w20dpmvnot0xfjyjo', 'post', config)
}
